module.exports = __webpack_public_path__ + "img/news2.df50024b.png";